import { render } from "./IndicatorTimeframeTrend.vue?vue&type=template&id=2fd2c232&scoped=true"
import script from "./IndicatorTimeframeTrend.vue?vue&type=script&lang=js"
export * from "./IndicatorTimeframeTrend.vue?vue&type=script&lang=js"

import "./IndicatorTimeframeTrend.vue?vue&type=style&index=0&id=2fd2c232&scoped=true&lang=css"
import "./IndicatorTimeframeTrend.vue?vue&type=style&index=1&id=2fd2c232&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd2c232"]])

export default __exports__